__webpack_require__.p = "https://assets.mindtickle.com/ui-shell/ux-refresh-prod-ldr/production/";